import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-app/cloud_app_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner">
                Cloud Application Development Company
              </h1>
              <span>Build Scalable Cloud Applications</span>
              <p>
                Develop your cloud-powered app in collaboration with TekRevol, a
                reliable firm specializing in cloud application development
                services. Whether you want to build a fully customized app from
                scratch or migrate the existing one, our cloud experts are right
                here to help you. You can rely on us for both SMEs and
                enterprise-level cloud-based solutions.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book Consultation
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
